__turbopack_context__.v({
  "align-center": "CategoryBannerItem-module-scss-module__ROyXzq__align-center",
  "align-left": "CategoryBannerItem-module-scss-module__ROyXzq__align-left",
  "align-right": "CategoryBannerItem-module-scss-module__ROyXzq__align-right",
  "backgroundImage": "CategoryBannerItem-module-scss-module__ROyXzq__backgroundImage",
  "backgroundVideo": "CategoryBannerItem-module-scss-module__ROyXzq__backgroundVideo",
  "backgroundWrapper": "CategoryBannerItem-module-scss-module__ROyXzq__backgroundWrapper",
  "banner": "CategoryBannerItem-module-scss-module__ROyXzq__banner",
  "card": "CategoryBannerItem-module-scss-module__ROyXzq__card",
  "colorBackground": "CategoryBannerItem-module-scss-module__ROyXzq__colorBackground",
  "content": "CategoryBannerItem-module-scss-module__ROyXzq__content",
  "cta": "CategoryBannerItem-module-scss-module__ROyXzq__cta",
  "ctaText": "CategoryBannerItem-module-scss-module__ROyXzq__ctaText",
  "gradient": "CategoryBannerItem-module-scss-module__ROyXzq__gradient",
  "hover-darken": "CategoryBannerItem-module-scss-module__ROyXzq__hover-darken",
  "hover-glow": "CategoryBannerItem-module-scss-module__ROyXzq__hover-glow",
  "hover-lift": "CategoryBannerItem-module-scss-module__ROyXzq__hover-lift",
  "hover-none": "CategoryBannerItem-module-scss-module__ROyXzq__hover-none",
  "hover-opaque": "CategoryBannerItem-module-scss-module__ROyXzq__hover-opaque",
  "hover-parallax": "CategoryBannerItem-module-scss-module__ROyXzq__hover-parallax",
  "hover-zoom": "CategoryBannerItem-module-scss-module__ROyXzq__hover-zoom",
  "parallaxOverlay": "CategoryBannerItem-module-scss-module__ROyXzq__parallaxOverlay",
  "productImage": "CategoryBannerItem-module-scss-module__ROyXzq__productImage",
  "productImageWrapper": "CategoryBannerItem-module-scss-module__ROyXzq__productImageWrapper",
  "subtitle": "CategoryBannerItem-module-scss-module__ROyXzq__subtitle",
  "title": "CategoryBannerItem-module-scss-module__ROyXzq__title",
  "transition-fade": "CategoryBannerItem-module-scss-module__ROyXzq__transition-fade",
  "transition-scale": "CategoryBannerItem-module-scss-module__ROyXzq__transition-scale",
  "transition-slideIn": "CategoryBannerItem-module-scss-module__ROyXzq__transition-slideIn",
  "transition-slideUp": "CategoryBannerItem-module-scss-module__ROyXzq__transition-slideUp",
  "visible": "CategoryBannerItem-module-scss-module__ROyXzq__visible",
});
